import middleware from '@/router/middleware';
import authentication from '@/router/middleware/authentication';
import unauthentication from '@/router/middleware/unauthentication';
import checkGlobalToken from '@/router/middleware/checkGlobalToken';

export default [
  {
    path: '/',
    name: 'Login',
    component: () => import('../../views/LoginV2.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../../views/ResetPasswordV2.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/first-access',
    name: 'firstAccess',
    component: () => import('../../views/firstAccess/FirstAccess.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/need-validate-document',
    name: 'needValidateDocument',
    component: () => import('../../views/firstAccess/NeedValidateDocument.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/has-not-account',
    name: 'hasNotAccount',
    component: () => import('../../views/firstAccess/HasNotAccount.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/set-password',
    name: 'setPassword',
    component: () => import('../../views/firstAccess/SetPassword.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../../views/Home2.vue'),
    beforeEnter: middleware([authentication, checkGlobalToken]),
  },
  {
    path: '/select-site',
    name: 'Selecionar Site',
    component: () => import('../../views/SelectSite.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },  
  {
    path: '/curso/:curso',
    name: 'curso',
    component: () => import('../../views/Player.vue'),
    beforeEnter: middleware([authentication]),
    meta: {
      showNavbar: true,
    },
  },
  {
    path: '/curso/:curso/modulo/:modulo/',
    name: 'modulo',
    component: () => import('../../views/Player.vue'),
    beforeEnter: middleware([authentication]),
    meta: {
      showNavbar: true,
    },
  },
  {
    path: '/curso/:curso/modulo/:modulo/aula/:aula',
    name: 'cursos',
    component: () => import('../../views/Player.vue'),
    beforeEnter: middleware([authentication]),
    meta: {
      showNavbar: true,
      showSlideBar: true,
    },
  },
  {
    path: '/config_curso',
    name: 'config_curso',
    component: () => import('../../views/CreateCourse.vue'),
    beforeEnter: middleware([authentication]),
    children: [
      {
        path: ':curso',
        name: 'config_curso_param',
        component: () => import('../../views/CreateCourse.vue'),
        beforeEnter: middleware([authentication]),       
      },
    ],
  },
  {
    path: '/config_curso/vendas/:curso/',
    name: 'curso',
    component: () => import('../../views/CreateCourseSale.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/config_curso/:curso/module',
    name: 'curso',
    component: () => import('../../views/CreateModule.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/config_curso/:curso/module/:module/lesson',
    name: 'curso',
    component: () => import('../../views/CreateLesson.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/config_curso/class/:curso',
    name: 'Sala de Aula',
    component: () => import('../../views/CreateClass.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/certificates',
    name: 'Certificados',
    component: () => import('../../views/Certificates.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/create-certificates/:curso',
    name: 'Certificados',
    component: () => import('../../views/CreateCertificates.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/curso/venda/:id',
    name: 'Vender Curso',
    component: () => import('../../views/SaleCourse.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/comentarios',
    name: 'Comentario',
    component: () => import('../../views/Comments.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/cards',
    name: 'Cards',
    component: () => import('../../views/Cards.vue'),
    beforeEnter: middleware([authentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/banners',
    name: 'Banner',
    component: () => import('../../views/CreateBanner.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/members',
    name: 'Membros',
    component: () => import('../../views/Members.vue'),
    beforeEnter: middleware([authentication]),
  },
  
  {
    path: '/minha-conta',
    name: 'Minha conta',
    component: () => import('../../views/MyAccount.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/ajuda',
    name: 'Ajuda',
    component: () => import('../../views/Helper.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/ajuda/:id',
    name: 'AjudaTicket',
    component: () => import('../../components/V2/TicketComponent.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/configuracoes',
    name: 'Meu Painel',
    component: () => import('../../views/MyPainel.vue'),
    beforeEnter: middleware([authentication]),
  },
  {
    path: '/not-project',
    name: 'Sem Projeto',
    component: () => import('../../views/NotProject.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/config-domain',
    name: 'Configurar Dominio',
    component: () => import('../../views/ConfigDomain.vue'),
    beforeEnter: middleware([unauthentication]),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/login-to-google/:auth',
    name: 'Login Google',
    component: () => import('../../views/LoginGoogleOff.vue'),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/redirect-gd/:token/:site_id',
    name: 'Login Google',
    component: () => import('../../views/Redirect.vue'),
    meta: {
      showNavbar: false,
    },
  },
  {
    path: '/assinatura',
    name: 'Assinaturas',
    component: () => import('../../views/Signature.vue'),
    beforeEnter: middleware([authentication]),
  },
];
